import parseQueryString from '../utils/parse-query-string';

export function LoadPackages(product_id) {
    return async function(dispatch) {
        dispatch({
            type: 'PACKAGES/LOAD',
        });

        let hotel_filter_query = '';
        let query = parseQueryString(document.location.search);
        if (query.hotelId != null) {
            hotel_filter_query = '?hotel_filter=' + query.hotelId;
        }

        const response = await fetch(
            `${application.titan_url}/api/events/${product_id}/shows` +
            hotel_filter_query,
            {
                headers: {
                    'Accept': 'application/json',
                },
            },
        );

        const result = await response.json();

        result.items.forEach((month) => {
            month.month = new Date(month.month * 1000);

            month.data.forEach((item) => {
                item.date = new Date(item.date * 1000);
                if (item.hotel) {
                    item.hotel.date = new Date(item.hotel.date * 1000);
                }

                if (item.ticket) {
                    item.ticket.date = new Date(item.ticket.date * 1000);
                }

                item.tickets.forEach((ticket) => {
                    ticket.date = new Date(ticket.date * 1000);
                });
            });
        });

        dispatch({
            type: 'PACKAGES/LOAD_FINISHED',
            payload: {
                packages: result.items,
                show_sold_out: result.show_sold_out,
            },
        });
    };
}

export function ReloadPackages(product_id) {
    return function(dispatch) {
        dispatch({
            type: 'APP/CLEAR',
        });

        dispatch(LoadPackages(NOJESRESOR_PRODUCT.id));
    };
}

export function FilterPackagesByMonth(month) {
    return function(dispatch) {
        dispatch({
            type: 'PACKAGES/FILTER',
            payload: {
                month: month,
            },
        });
    };
}

export function FilterPackagesByCity(city) {
    return function(dispatch) {
        dispatch({
            type: 'PACKAGES/FILTER',
            payload: {
                city: city,
            },
        });
    };
}

export function ShowEmptyDates() {
    return function(dispatch, getState) {
        const {data} = getState();
        dispatch({
            type: 'PACKAGES/FILTER',
            payload: {
                show_empty_dates: !data.show_empty_dates,
            },
        });
    };
}

export function SelectPackage(pkg) {
    return function(dispatch) {
        dispatch({
            type: 'PACKAGES/SELECT',
            payload: {
                package: pkg,
            },
        });
    };
}

export function DeselectPackage() {
    return function(dispatch) {
        dispatch({
            type: 'APP/CLEAR',
        });
    };
}

export function DeselectConfirmedPackage() {
    return function(dispatch) {
        dispatch({
            type: 'APP/CLEAR',
        });
    };
}
